import axios from 'axios';
import { saveAs } from 'file-saver';
import _ from 'lodash';
import Swal from 'sweetalert2';
import moment from 'moment';

import {
  EMP_FETCH_EMPRESAS_GO_ENTRADA_FAIL,
  EMP_FETCH_EMPRESAS_GO_ENTRADA_SUCCESS,
  EMP_FETCH_EMPRESAS_GO_FAIL,
  EMP_FETCH_EMPRESAS_GO_SUCCESS,
  EMP_FETCH_EMPRESAS_MT_FAIL,
  EMP_FETCH_EMPRESAS_MT_SUCCESS,
  EMP_REPLICAR_CREDENCIAIS_FAIL,
  EMP_REPLICAR_CREDENCIAIS_SUCCESS,
  EMP_SET_EMPRESA_FAIL,
  EMP_SET_EMPRESA_SUCCESS,
  EMP_SET_EMPRESAS_FAIL,
  EMP_SET_EMPRESAS_SUCCESS,
  SET_CARREGANDO_APLICACAO,
  EMP_FETCH_EMPRESAS_SC_ENTRADA_SUCCESS
} from './types';
import box from '../api/box';
import sentinela from '../api/sentinela';
import certificado from '../api/certificado';
import { ErrorMessages } from '../utils/ErrorMessages';
import {
  createErrorNotification,
  createSuccessNotification,
  sendErroRequest,
} from '../utils/Notification';

const urlBase = '/v1/empresas';

export const carregaAutenticacao = async (token, tenant) => {
  sessionStorage.setItem('token', token);
  sessionStorage.setItem('tenant', tenant);
};

export const logOutUser = () => {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('tenant');
};

export const setCarregandoAplicacao = payload => ({
  type: SET_CARREGANDO_APLICACAO,
  payload,
});

export const setEmpresaSuccess = values => ({
  type: EMP_SET_EMPRESA_SUCCESS,
  payload: values,
});

export const setEmpresaFail = () => ({
  type: EMP_SET_EMPRESA_FAIL,
});

export const setEmpresasSuccess = values => ({
  type: EMP_SET_EMPRESAS_SUCCESS,
  payload: values,
});

export const setEmpresasFail = () => ({
  type: EMP_SET_EMPRESAS_FAIL,
});

export const replicarCredenciaisSuccess = () => ({
  type: EMP_REPLICAR_CREDENCIAIS_SUCCESS,
});

export const replicarCredenciaisFail = () => ({
  type: EMP_REPLICAR_CREDENCIAIS_FAIL,
});

export const fetchEmpresasMtSuccess = payload => ({
  type: EMP_FETCH_EMPRESAS_MT_SUCCESS,
  payload,
});

export const fetchEmpresasMtFail = () => ({
  type: EMP_FETCH_EMPRESAS_MT_FAIL,
});

export const fetchEmpresasGoEntradaSuccess = payload => ({
  type: EMP_FETCH_EMPRESAS_GO_ENTRADA_SUCCESS,
  payload,
});

export const fetchEmpresasSCSuccess = payload => ({
  type: EMP_FETCH_EMPRESAS_SC_ENTRADA_SUCCESS,
  payload,
});

export const fetchEmpresasGoEntradaFail = () => ({
  type: EMP_FETCH_EMPRESAS_GO_ENTRADA_FAIL,
});

export const fetchEmpresasGoSuccess = payload => ({
  type: EMP_FETCH_EMPRESAS_GO_SUCCESS,
  payload,
});

export const fetchEmpresasGoFail = () => ({
  type: EMP_FETCH_EMPRESAS_GO_FAIL,
});

export const getEmpresas = () => async (dispatch, getState) => {
  const {
    usuario: { pessoaLogada },
  } = getState();

  try {
    const { data } = await sentinela.get(`/usuarios/${pessoaLogada.usuarioId}/tenants`);

    dispatch(
      setEmpresasSuccess(data ? _.filter(data.tenants, tenant => tenant.modulo === 16) : []),
    );
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar as Empresas');

    dispatch(setEmpresasFail());
  }
};

export const getEmpresa = () => async dispatch => {
  try {
    const [{ data }, { data: configuracaoBloqueioCfop }] = await Promise.all([
      box.get(urlBase),
      box.get('/v1/bloqueio-cfop/configuracao'),
    ]);

    const empresa = await verifyInscricaoEmpresa(data)
    empresa.configuracaoBloqueioCfop = configuracaoBloqueioCfop;

    dispatch(setEmpresaSuccess(empresa));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar os dados da Empresa');

    dispatch(setEmpresaFail());
  }
};

const verifyInscricaoEmpresa = async (empresa) => {
  if (empresa.inscricao.length === 11) {
    if (empresa.tipoInscricao !== 2) {
      empresa.tipoInscricao = 2
      await box.put(urlBase, empresa);
    }
  } else {
    if (empresa.tipoInscricao !== 1) {
      empresa.tipoInscricao = 1
      await box.put(urlBase, empresa);
    }
  }
  return empresa
}

export const putEmpresa = (empresa, cb) => async (dispatch, getState) => {
  try {
    const { configuracaoBloqueioCfop, ...empresaAtualizar } = empresa;


    const {
      empresa: { dadosEmpresa },
    } = getState();

    if (empresaAtualizar.emailPrincipal !== dadosEmpresa.emailPrincipal) {
      const { value } = await Swal.fire({
        title: 'Confirma a inclusão desse novo usuário?',
        text: `Assim que você confirmar esse cadastro, um e-mail será automaticamente encaminhado ao seu cliente
               para notificá-lo sobre a permissão de acesso a aplicação Tron Box.`,
        type: 'warning',
        focusCancel: true,
        showCancelButton: true,
        confirmButtonColor: '#18a689',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sim, pode criar!',
      });

      if (!value) return;
    }

    if (
      empresaAtualizar.configuracaoEmpresa &&
      empresaAtualizar.configuracaoEmpresa.inscricoesComplementares
    ) {
      for (const inscricaoComplementar of empresaAtualizar.configuracaoEmpresa
        .inscricoesComplementares) {
        if (inscricaoComplementar && inscricaoComplementar.codigoCidade === null) {
          inscricaoComplementar.codigoCidade = 0;
        }
      }
    }

    /*
     * TODO:
     * Realizar melhoria para que os dados de acesso de MT e MS inseridos sejam primeiro validados no
     * respectivo portal da Sefaz antes de defini-los como válidos de fato.
     */
    if (
      empresaAtualizar.configuracaoEmpresa &&
      empresaAtualizar.configuracaoEmpresa.dadosMatoGrosso
    ) {
      empresaAtualizar.configuracaoEmpresa.dadosMatoGrosso.dadosInvalidos = false;
    }

    if (
      empresaAtualizar.configuracaoEmpresa &&
      empresaAtualizar.configuracaoEmpresa.dadosMatoGrossoSul
    ) {
      empresaAtualizar.configuracaoEmpresa.dadosMatoGrossoSul.dadosInvalidos = false;
    }

    const { data } = await box.put(urlBase, empresaAtualizar);
    const { data: configuracaoSalva } = await box.put(
      '/v1/bloqueio-cfop/configuracao',
      configuracaoBloqueioCfop || { ativo: false, cfopsBloqueados: [] },
    );

    if (empresaAtualizar.configuracaoEmpresa.certificadoContador) {
      const formData = new FormData();
      formData.append(
        "arquivoContador",
        empresaAtualizar.configuracaoEmpresa.certificadoContador.arquivoContador
      );
      formData.append(
        "inscricaoContador",
        empresaAtualizar.configuracaoEmpresa.certificadoContador.inscricaoContador
      );
      formData.append(
        "senhaContador",
        empresaAtualizar.configuracaoEmpresa.certificadoContador.senhaContador
      );

      await dispatch(uploadCertificadoContador(formData))
    }

    createSuccessNotification(data.mensagem);

    if (configuracaoSalva.desativadoAutomaticamente) {
      createErrorNotification('O bloqueio foi desativado porque nenhum CFOP foi selecionado.');
    }

    dispatch(setEmpresaSuccess({
      ...empresaAtualizar,
      configuracaoBloqueioCfop: configuracaoSalva,
    }));

    if (cb && typeof cb === 'function') cb();
  } catch (error) {
    sendErroRequest(error, 'Não foi possível atualizar os dados da Empresa');

    dispatch(setEmpresaFail());
  }
};

export const uploadCertificado = (certificado, cb) => async () => {
  try {
    const formData = new FormData();

    formData.append('inscricaoEmpresa', certificado.inscricao);
    formData.append('senha', certificado.senha);
    formData.append('arquivo', certificado.arquivo);

    await box.post(`${urlBase}/certificado/upload`, formData);

    if (cb && typeof cb === 'function') cb();
  } catch (error) {
    if (error.response) {
      const {
        response: { data },
      } = error;

      const errorMessage =
        data.erros && data.erros.length > 0 ? data.erros[0].chave : data.mensagem;

      const message = ErrorMessages[errorMessage];

      if (message) createErrorNotification(message);
      else sendErroRequest(error, 'Não foi possível enviar o certificado.');
    } else sendErroRequest(error, 'Não foi possível enviar o certificado.');

    if (cb && typeof cb === 'function') cb();
  }
};

export const deleteCertificado = (id, cb) => async () => {
  try {
    await box.delete(`${urlBase}/certificado/${id}`);
    if (cb && typeof cb === 'function') cb();
  } catch (error) {
    sendErroRequest(error, 'Não foi possível deletar o certificado.');
  }
};

// O blob de certificados é privado: o backend gera um link temporário (10 minutos) a cada download.
export const downloadCertificado = () => async () => {
  try {
    const { data: download } = await box.post(`${urlBase}/certificado/url-download`);
    const { data } = await axios.get(download.url, { responseType: 'blob' });

    saveAs(data, `${download.inscricaoEmpresa}.pfx`);
  } catch (error) {
    sendErroRequest(error, 'Não foi possível baixar o certificado.');
  }
};

export const trocarEmpresa = id => dispatch => {
  const token = sessionStorage.getItem('token');

  dispatch([
    setCarregandoAplicacao(true),
    logOutUser(),
    carregaAutenticacao(token, id),
    window.location.reload(),
    setCarregandoAplicacao(false),
  ]);
};

export const getHistoricoCertificado = async () => {
  try {
    const { data: { inscricao } } = await box.get(urlBase);
    const { data } = await certificado.get(`v1/certificados/${inscricao}?includeDeleted=true`);

    if (!data) {
      return []
    }

    let historicoCertificado = []
    if (!data.certificadoExcluido) {
      historicoCertificado = [{
        id: data.dataArmazenamento,
        dataArmazenamento: getValidDate(data.dataArmazenamento),
        dataVencimento: getValidDate(data.dataVencimento),
        dataExclusao: 'Certificado atual',
      }]
    }

    const historicoAlteracoes = data.historicoCertificado.length > 0 ? data.historicoCertificado.map(historico => ({
      id: historico.dataArmazenamento,
      dataArmazenamento: getValidDate(historico.dataArmazenamento),
      dataVencimento: getValidDate(historico.dataVencimento),
      dataExclusao: getValidDate(historico.dataExclusao),
    })) : []

    const historico = [...historicoCertificado, ...historicoAlteracoes];

    return historico;
  } catch (error) {
    sendErroRequest(error, 'Não foi possível resgatar histórico do certificado.');
  }
}

export const getValidDate = (date) => {
  if (date) {
    const dateFormatted = moment(date, 'YYYYMMDDHHmm');
    return dateFormatted.isValid() ? dateFormatted.format('DD/MM/YYYY - HH:mm') : date;
  }

  return undefined;
};

export const replicarCredenciais = (tenants = []) => async dispatch => {
  try {
    await box.put(`${urlBase}/replicar-configuracao-acesso`, tenants);
    createSuccessNotification('As credenciais foram replicadas.');
    return dispatch(replicarCredenciaisSuccess());
  } catch (error) {
    sendErroRequest(error, 'Não foi possível replicar as credenciais.');
    return dispatch(replicarCredenciaisFail());
  }
};

export const fetchEmpresasMt = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/mt`);
    return dispatch(fetchEmpresasMtSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar as empresas.');
    return fetchEmpresasMtFail();
  }
};

export const fetchEmpresasGoEntrada = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/go-entrada`);
    console.log(`Data ${data[0]}`)
    return dispatch(fetchEmpresasGoEntradaSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar as empresas.');
    return fetchEmpresasGoEntradaFail();
  }
};


export const fetchEmpresasSC = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/sc`);

    return dispatch(fetchEmpresasSCSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar as empresas.');

  }
};

export const fetchEmpresasGo = () => async dispatch => {
  try {
    const { data } = await box.get(`${urlBase}/go`);
    console.log(`Data ${data[0]}`)
    return dispatch(fetchEmpresasGoSuccess(data));
  } catch (error) {
    sendErroRequest(error, 'Não foi possível buscar as empresas.');
    return fetchEmpresasGoFail();
  }
};


export const uploadCertificadoContador = (formData) => async (dispatch) => {
  try {
    await box.post(`${urlBase}/certificadoContador/upload`, formData);
    
    createSuccessNotification("Dados atualizados com sucesso!");
  } catch (error) {
    console.log('Upload error:', error.response && error.response.status, error.response && error.response.data);
    sendErroRequest(error, 'Não foi possível enviar o certificado e os dados do contador.');
    throw error; 
  }
};

export const deleteCertificadoContador = (id) => async () => {
  try {
    const { value } = await Swal.fire({
      title: 'Deletar certificado do Contador?',
      text: `Assim que você deletar todos os serviços que dependem do certificado do contador vão parar de funcionar`,
      type: 'warning',
      focusCancel: true,
      showCancelButton: true,
      confirmButtonColor: '#18a689',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, Deletar',
    });

    if (!value) return;
    await box.delete(`${urlBase}/certificado/contador/${id}`);
    createSuccessNotification("Certificado deletado com sucessp!");
    return true
  } catch (error) {
    sendErroRequest(error, 'Não foi possível deletar o certificado.');
    return false
  }
};
